import { getErrorMessage } from "./get-error-message";

export class ApiError extends Error {
  code: string;

  constructor(code: string, message?: string) {
    super(message);
    this.code = code;
    this.message = message || this.getMessageFromCode(code);
    this.name = "ApiError";
  }

  private getMessageFromCode(code: string): string {
    return getErrorMessage(code);
  }
}
